import { Checkbox } from "@material-ui/core";
import styled from "styled-components";

export const StyledCheckbox = styled(Checkbox)`
  & .MuiSvgIcon-root {
    font-size: 2rem;
  }
`;
